import dataModel from '../models/DataModel';
import ModalBannerConstants from '../constants/ModalBannerConstants';

/**
 * Handles ActionCable updates for Progress Reports
 * Returns a function to fetch the progress report if needed
 */
function handleActionCableAndGetRequest(acData) {
  // Show banner notification when progress report is ready
  if (acData.sub_type === 'progress_report_completed') {
    showProgressReportBanner(acData);
  }
  
  // Return null since we don't need to fetch/cache progress reports
  return null;
}

/**
 * Shows the progress report notification banner
 * Only shown to the user who requested it
 */
function showProgressReportBanner(acData) {
  const loggedInUserId = parseInt(localStorage.loggedin_user_id, 10);
  
  if (acData.updating_user_id == loggedInUserId) {
    dataModel.showGlobalBanner(ModalBannerConstants.CLOSEOUT_NOTIFICATION_BANNER, {
      closeoutableName: acData.project_name || 'Project',
      projectId: acData.project_id,
      isMobile: false,
      documentType: 'progressReport',
    });
  }
}

export default {
  handleActionCableAndGetRequest,
};



// WEBPACK FOOTER //
// ./src/dao/ProgressReportsDAO.js